import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

type Mode =
    | 'float'
    | 'ingress'
    | 'egress'
    | 'eye'
    | 'orbit'
    | 'streamVertical'
    | 'streamHorizontal'
    | 'pulse'
    | 'scan'
    | 'glitch';

@Component({
    selector: 'app-loading-logo',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './loadinglogo.component.html',
    styleUrl: './loadinglogo.component.css',
    encapsulation: ViewEncapsulation.None,
})
export class LoadingLogoComponent {
    @Input({ required: true }) orb!: { cx: number; cy: number; r: number };
    @Input({ required: true }) eye!: { fx: number; fy: number; t: number };
    @Input({ required: true }) mode!: Mode;
    @Input({ required: true }) particles: Array<{ id: number; text: string; x: number; y: number; size: number; opacity: number }> = [];
    @Input({ required: true }) showEyelids = true;
    @Input({ required: true }) showBrackets = true;
    @Input({ required: true }) particleVars!: (p: any) => string;

    trackById = (_: number, p: { id: number }) => p.id;
}
